<template>
  <router-link :to="{name: $props.to, params: $props.params}"
    class="menu-tab"
    active-class="menu-tab--active" replace>
    {{ $props.text }}
  </router-link>
</template>

<script>
export default {
  name: 'MenuTab',
  props: {
    to: {
      required: true,
      type: String,
    },
    text: {
      required: true,
      type: String,
    },
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
  }
}
</script>

<style lang="scss" scoped>
.menu-tab {
  padding: 10px 19px;
  font-size: 14px;
  color: $surfaceDarker;
  text-decoration: none;
  white-space: nowrap;
  transition: text-shadow ease-in-out .3s;

  &--active {
    background: #fff;
    border-radius: 5px 5px 0 0;
    box-shadow: 0px -4px 5px rgba(198, 209, 237, 0.37);
    text-shadow: .25px 0px .1px,
                -.25px 0px .1px;
  }

  &:hover {
    text-shadow: .25px 0px .1px,
                -.25px 0px .1px;
  }

}
</style>